module.exports = __webpack_public_path__ + "static/img/fish20.b8417fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish20.png
// module id = u1dG
// module chunks = 0